// Constants - defined at top level to avoid duplication
const SPECIAL_TITLES = [
  "Blood taken by a professional in-clinic",
  "Book a home nurse visit to have your blood sample taken",
  "In clinic appointment"
];
const SPECIAL_TITLES_CLINIC = [
  "Blood taken by a professional in-clinic",
  "In clinic appointment"
];
const SPECIAL_TITLES_MOBILE = [
  "Book a home nurse visit to have your blood sample taken"
];
const TITLES_HOME_TESTS = [
  "Blood taken at home via finger-prick kit",
  "Organise my own blood collection",
  "Collect Sample at Home",
  "1 Body Part",
  "2 Body Parts",
  "Full Body MRI Scan – Gold",
  "Full Body MRI Scan – Gold with prostate screening",
  "Full Body MRI Scan – Platinum",
  "Full Body MRI Scan – Platinum with prostate screening",
];
const SPECIAL_TITLES_HOME = [
  "Blood taken at home via finger-prick kit",
  "Organise my own blood collection",
  "Collect Sample at Home"
];

// Discount for home test upsells (sample taken at home and sent to be processed)
// This is a placeholder that can be easily changed in the future
const HOME_TEST_UPSELL_DISCOUNT = 0;

// Constants
const VARIANT_CHANGE_DELAY = 400; // ms delay for variant change handler

// Helper function to parse price strings that may contain commas (e.g., "1,499.00")
function parsePrice(priceString) {
  if (typeof priceString === 'number') {
    return priceString;
  }
  if (typeof priceString !== 'string') {
    return 0;
  }
  // Remove commas and parse as float
  return parseFloat(priceString.replace(/,/g, '')) || 0;
}

// Helper function to get selected variant ID using multiple methods
function getSelectedVariantId() {
  // First, try to get from data-selected-variant script (most reliable for all product types)
  const selectedVariantsScript = document.querySelector('[data-selected-variant]');
  if (selectedVariantsScript) {
    try {
      const selectedVariants = JSON.parse(selectedVariantsScript.textContent);
      if (selectedVariants && selectedVariants.id) {
        return Number(selectedVariants.id);
      }
    } catch (e) {
      console.error('Error parsing selected variant:', e);
    }
  }
  
  // If not found, try to get variant from radio buttons (for blood tests with Collection Method, Options, or Recording)
  const selectedRadio = $(
    'input[type="radio"][name*="Collection Method-1"]:checked, ' +
    'input[type="radio"][name*="Options-1"]:checked, ' +
    'input[type="radio"][name*="Recording-1"]:checked'
  );
  
  if (selectedRadio.length) {
    const variantId = selectedRadio.closest('label').find('.var_price').data('nid');
    if (variantId) {
      return Number(variantId);
    }
  }
  
  // If still not found, try to get from any checked radio button with var_price
  const anyCheckedRadio = $('input[type="radio"]:checked');
  if (anyCheckedRadio.length) {
    const variantId = anyCheckedRadio.closest('label').find('.var_price').data('nid');
    if (variantId) {
      return Number(variantId);
    }
  }
  
  // If still not found, try to get from the form's hidden variant input (standard Shopify method)
  const variantInput = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
  if (variantInput && variantInput.value) {
    const variantId = Number(variantInput.value);
    if (!isNaN(variantId)) {
      return variantId;
    }
  }
  
  return null;
}

// Helper function to save product data to sessionStorage
function saveProductDataToSession(data) {
  Object.keys(data).forEach(key => {
    if (data[key] !== null && data[key] !== undefined) {
      sessionStorage.setItem(key, data[key]);
    }
  });
}

// Helper function to create cart item properties from patient data
function createCartItemProperties(patientData, productHandle, eurofinsCode) {
  const properties = {
    'First Name': patientData.firstName || '',
    'Last Name': patientData.lastName || '',
    'Date of Birth': patientData.dob ? patientData.dob.split('-').reverse().join('/') : '',
    'Gender': patientData.gender || ''
  };
  
  if (productHandle && productHandle !== 'undefined') {
    properties.product_id = productHandle;
  }
  
  if (eurofinsCode && eurofinsCode !== 'undefined') {
    properties.product_code = eurofinsCode;
  }
  
  return properties;
}

// Helper function to get metafields element (cached)
function getMetafieldsElement() {
  return document.getElementById('product-metafields');
}

// Helper function to get and parse upsells from metafields
function getUpsellsFromMetafields() {
  const metafieldsEl = getMetafieldsElement();
  if (!metafieldsEl || !metafieldsEl.dataset.upsells) {
    return null;
  }
  try {
    return JSON.parse(metafieldsEl.dataset.upsells);
  } catch (e) {
    console.error('Error parsing upsells:', e);
    return null;
  }
}

//JS for changing the display depending on variant type (show postcode search for mobile and show book now or add to cart) 
$(document).on('change', 'input[type="radio"][name*="Collection Method-1"]', function () {
  const collMethod = $(this).val();
  const submitButtonSpan = document.querySelector('product-form [type="submit"] span');

  setTimeout(() => {
    if (submitButtonSpan) {
      if (SPECIAL_TITLES.includes(collMethod)) {
        submitButtonSpan.textContent = "Book now";
        jQuery(".shopify-payment-button").hide();
      } else {
        submitButtonSpan.textContent = window.variantStrings?.addToCart || "Add to cart";
        if (TITLES_HOME_TESTS.includes(collMethod)) {
          jQuery(".shopify-payment-button").hide();
        } else {
          jQuery(".shopify-payment-button").show();
        }
      }
    }
    if (SPECIAL_TITLES_MOBILE.includes(collMethod)) {
      jQuery("#mobileBookingPostcodeCheck").removeClass('disp_none');
    } else {
      jQuery("#mobileBookingPostcodeCheck").addClass('disp_none');
    }
  }, VARIANT_CHANGE_DELAY);
});


// Helper function to save upsells to sessionStorage
function saveUpsellsToSession() {
  const metafieldsEl = getMetafieldsElement();
  if (metafieldsEl && metafieldsEl.dataset.upsells) {
    sessionStorage.setItem('upsells', metafieldsEl.dataset.upsells);
  }
}

// Helper function to get variant SKU from selected radio button
function getVariantSku() {
  const selectedRadio = $('input[type="radio"][name*="Collection Method-1"]:checked');
  if (selectedRadio.length) {
    return selectedRadio.closest('label').find('.var_price').data('sku');
  }
  return null;
}

// JS for redirecting to the right booking page for mobile and in clinic booking
$('product-form [type="submit"]').on('click', function(e) {
  const collectionMethod = $(
      'input[type="radio"][name*="Collection Method-1"]:checked, ' +
      'input[type="radio"][name*="Options-1"]:checked, ' +
      'input[type="radio"][name*="Recording-1"]:checked'
  ).val();

  // Get variant ID using helper function (works for all product types)
  const variantId = getSelectedVariantId();
  const variantSku = getVariantSku();
  const productHandle = $('#product-handle').val();
  const realProductHandle = $('#real-product-handle').val();
  const eurofins_code = $('#eurofins_code').val();
  const productTitle = $('#product-title').val();
  const aptId = $('#aptId').val();

  if (SPECIAL_TITLES_CLINIC.includes(collectionMethod)) {
    e.preventDefault();
    e.stopPropagation();

    if (!variantId) {
      alert('Please select a product variant.');
      return;
    }

    // Save to sessionStorage
    saveProductDataToSession({
      variant_id: variantId,
      variant_sku: variantSku,
      aptId: aptId,
      product_handle: productHandle,
      real_product_handle: realProductHandle,
      eurofinsCode: eurofins_code,
      product_title: productTitle
    });
    saveUpsellsToSession();

    window.location.href = '/pages/find-clinic';

  } else if (SPECIAL_TITLES_MOBILE.includes(collectionMethod)) {
    e.preventDefault();
    e.stopPropagation();
    
    if (!variantId) {
      alert('Please select a product variant.');
      return;
    }
    
    const postCode = $('#preSearchFormobile_venous').val();

    // Save to sessionStorage
    saveProductDataToSession({
      variant_id: variantId,
      product_handle: productHandle,
      aptId: aptId,
      eurofinsCode: eurofins_code,
      product_title: productTitle,
      postCode: postCode,
      variant_sku: variantSku
    });
    saveUpsellsToSession();

    window.location.href = '/pages/check-mobile-availability';

  } else if (TITLES_HOME_TESTS.includes(collectionMethod)) {
    e.preventDefault();
    e.stopPropagation();
    const modal = document.getElementById('thankYouModal');
    const backdrop = document.getElementById('modalBackdrop');
    if (modal) modal.style.display = 'block';
    if (backdrop) backdrop.style.display = 'block';
    return;
  }
});

window.closeThankYouModal = function() {
  const modal = document.getElementById('thankYouModal');
  const backdrop = document.getElementById('modalBackdrop');
  if (modal) modal.style.display = 'none';
  if (backdrop) backdrop.style.display = 'none';
  // Clear temp patient data when closing
  window.tempPatientData = null;
};

window.continueToAddToBasket = async function(e) {
  // Prevent any default form submission
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }

  const firstNameInput = document.getElementById('modal-firstName');
  const lastNameInput = document.getElementById('modal-lastName');
  const dobInput = document.getElementById('modal-dob');
  const genderInputs = document.querySelectorAll('input[name="modal-gender"]');
  let selectedGender = '';

  genderInputs.forEach(function(input) {
    if (input.checked) {
      selectedGender = input.value;
    }
  });

  if (!firstNameInput.value) {
    alert('Please enter the patient\'s first name before continuing.');
    return;
  }
  if (!lastNameInput.value) {
    alert('Please enter the patient\'s last name before continuing.');
    return;
  }
  if (!dobInput.value) {
    alert('Please enter the patient\'s date of birth before continuing.');
    return;
  }

  if (!selectedGender) {
    alert('Please select the patient\'s gender before continuing.');
    return;
  }

  // Store patient details temporarily for later use
  window.tempPatientData = {
    firstName: firstNameInput.value,
    lastName: lastNameInput.value,
    dob: dobInput.value,
    gender: selectedGender
  };

  // Check if upsells are available
  const upsells = getUpsellsFromMetafields();

  if (upsells && Array.isArray(upsells) && upsells.length > 0) {
    // Show upsells as step 2 in the same modal (wizard style)
    showUpsellStep(upsells);
    return; // IMPORTANT: Stop execution here
  }

  // No upsells, proceed directly to add to cart
  const sectionEl = document.querySelector('[data-section-id]');
  const sectionId = sectionEl?.dataset.sectionId || null;
  const productSubmitButtonId = "ProductSubmitButton-" + sectionId;

  // Create hidden inputs to pass the patient details as product properties
  addPropertiesToForm(firstNameInput.value, lastNameInput.value, dobInput.value, selectedGender);

  // Validate variant selection using helper function
  const variantId = getSelectedVariantId();
  if (!variantId) {
    alert('Please select a product variant.');
    return;
  }

  closeThankYouModal();
  const submitButton = document.getElementById(productSubmitButtonId);
  if (submitButton && submitButton.closest('form')) {
    submitButton.closest('form').submit();
  } else {
    console.error('Submit button or form not found');
    alert('Unable to proceed. Please refresh the page and try again.');
  }
};

function addPropertiesToForm(firstName, lastName, dob, gender) {
  // Remove any existing property inputs
  const existingInputs = document.querySelectorAll('input[name^="properties["]');
  existingInputs.forEach(input => input.remove());

  const form = document.querySelector('form[data-type="add-to-cart-form"]');
  if (!form) {
    console.error('Add to cart form not found');
    return;
  }

  // Helper function to create and append hidden input
  const addHiddenInput = (name, value) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  };

  // Add patient details
  addHiddenInput('properties[First Name]', firstName);
  addHiddenInput('properties[Last Name]', lastName);
  addHiddenInput('properties[Date of Birth]', dob.split('-').reverse().join('/'));
  addHiddenInput('properties[Gender]', gender);

  // Add product identifiers if available
  const productHandle = $('#product-handle').val();
  const eurofins_code = $('#eurofins_code').val();

  if (productHandle && productHandle !== 'undefined') {
    addHiddenInput('properties[product_id]', productHandle);
  }

  if (eurofins_code && eurofins_code !== 'undefined') {
    addHiddenInput('properties[product_code]', eurofins_code);
  }
}

// Wizard Step 2: Show Upsells in the same modal
window.showUpsellStep = function(upsells) {
  const modal = document.getElementById('thankYouModal');
  const modalContent = modal ? modal.querySelector('.thank-you-modal__content') : null;

  if (!modal || !modalContent) {
    console.error('Modal or modalContent not found!');
    return;
  }

  // Create step 2 content (upsells)
  let upsellListHtml = '';
  let hasUpsells = false;

  upsells.forEach((product, index) => {
    let skip = 1;
    let product_id;
    let product_price;
    let product_discount;

    // If product has variants, find the appropriate variant for home test kits
    // Follow same pattern as section-book-appointment.js
    if (product.title.toLowerCase().includes('gp consultation') || product.title.toLowerCase().includes('mri')) {
      // For GP consultation and MRI, use first variant
      if (product.variants && product.variants.length > 0) {
        const variant = product.variants[0];
        skip = 0;
        product_id = variant.id;
        product_price = parsePrice(product.price);
        product_discount = 0;
      }
    } else {
      // For other products, try to find home test variant first
      // Apply configurable discount for home test upsells
      if (product.variants && product.variants.length > 0) {
        product.variants.forEach(variant => {
          if (SPECIAL_TITLES_HOME.includes(variant.title)) {
            skip = 0;
            product_id = variant.id;
            product_price = parsePrice(variant.price) - HOME_TEST_UPSELL_DISCOUNT;
            product_discount = HOME_TEST_UPSELL_DISCOUNT;
          }
        });
      }
    }

    if (skip === 0 && product_id) {
      hasUpsells = true;
      const checkboxId = `home_upsell_${index}`;
      const productImage = product.image || '';
      const productImageAlt = product.image_alt || product.title || '';

      upsellListHtml += `
        <div class="bolton-item" style="margin-bottom: 16px; display: flex; align-items: flex-start; gap: 12px;">
          <input 
            class="bolt_on_option_box boltonCheckbox" 
            type="checkbox" 
            style="width: 20px; height: 20px; vertical-align: middle; margin-top: 2px; flex-shrink: 0;" 
            id="${checkboxId}" 
            value="${product_id}" 
            data-desc_title="${product.title}"
            data-handle="${product.handle}"
            data-eurofins_code="${product.eurofins_code}"
            data-price="${product_price}">
          ${productImage ? `<img src="${productImage}" alt="${productImageAlt}" style="width: 80px; height: 80px; object-fit: cover; border-radius: 4px; flex-shrink: 0;" loading="lazy">` : ''}
          <label for="${checkboxId}" style="flex: 1; cursor: pointer; display: flex; flex-direction: column; justify-content: center;">
            <span style="font-weight: 500; margin-bottom: 4px;">${product.title}</span>
            <span style="font-size: 1.5rem;">&pound;${product_price.toFixed(2)}</span>
            ${product_discount > 0 ? `<i style="font-size: 1rem; color: #666;">(&pound;${product_discount.toFixed(2)} off regular price)</i>` : ''}
          </label>
        </div>
      `;
    }
  });

  if (hasUpsells && upsellListHtml.length > 0) {
    // Ensure modal is visible
    modal.style.display = 'block';
    const backdrop = document.getElementById('modalBackdrop');
    if (backdrop) backdrop.style.display = 'block';

    // Replace modal content with step 2 (upsells)
    modalContent.innerHTML = `
      <div class="product-form__firstName" style="margin-bottom: 24px; font-weight:700; text-align: center;">
        <p>We Recommend Adding</p>
      </div>
      <div id="upsellList" style="margin-bottom: 24px;">
        ${upsellListHtml}
      </div>
      <button type="button" class="inter_btn" onclick="goBackToPatientDetails()" style="margin-top: 16px; margin-bottom: 12px; display:block; border:0; width:100%; background: #f0f0f0; color: #333; padding: 12px; cursor: pointer; justify-content: center;">Back</button>
      <button type="button" class="inter_btn" id="continueToCheckoutButton" onclick="continueToCheckoutWithUpsells()" style="margin-top: 16px; display:block; border:0; width:100%; cursor: pointer; justify-content: center;">Continue</button>
    `;
  } else {
    // No upsells to show, proceed directly to checkout
    continueToCheckoutWithUpsells();
  }
};

// Go back to step 1 (patient details)
window.goBackToPatientDetails = function() {
  const modal = document.getElementById('thankYouModal');
  if (!modal) return;
  
  const modalContent = modal.querySelector('.thank-you-modal__content');
  if (!modalContent) return;
  
  const patientData = window.tempPatientData || {};

  // Restore step 1 content (patient details form)
  modalContent.innerHTML = `
    <div class="product-form__firstName" style="margin-bottom: 24px;font-weight:700;">
      <p>Please enter the patient's details</p>
    </div>
    <div class="product-form__firstName" style="margin-bottom: 24px;">
      <label for="modal-firstName" class="label" style="display: block; margin-bottom: 8px;">First Name:</label>
      <input type="text" id="modal-firstName" name="modal-firstName" required="" tabindex="1" enterkeyhint="next" class="input input--text" style="width: 100%; padding: 8px;font-family: Inter, sans-serif;" value="${patientData.firstName || ''}">
    </div>
    <div class="product-form__lastName" style="margin-bottom: 24px;">
      <label for="modal-lastName" class="label" style="display: block; margin-bottom: 8px;">Last Name:</label>
      <input type="text" id="modal-lastName" name="modal-lastName" required="" tabindex="2" enterkeyhint="next" class="input input--text" style="width: 100%; padding: 8px;font-family: Inter, sans-serif;" value="${patientData.lastName || ''}">
    </div>
    <div class="product-form__dob" style="margin-bottom: 24px;">
      <label for="modal-dob" class="label" style="display: block; margin-bottom: 8px;">Date of Birth:</label>
      <input type="date" id="modal-dob" name="modal-dob" required="" tabindex="3" enterkeyhint="next" class="input input--text" style="width: 100%; padding: 8px;font-family: Inter, sans-serif;" value="${patientData.dob || ''}">
    </div>
    <div class="product-form__gender" style="margin-bottom: 24px;">
      <label class="label" style="display: block; margin-bottom: 8px;">Gender:</label>
      <div style="margin-bottom: 8px;">
        <input type="radio" id="gender-male" name="modal-gender" tabindex="4" value="Male" required="" ${patientData.gender === 'Male' ? 'checked' : ''}>
        <label for="gender-male" class="label label--inline">Male</label>
      </div>
      <div>
        <input type="radio" id="gender-female" name="modal-gender" tabindex="5" value="Female" required="" ${patientData.gender === 'Female' ? 'checked' : ''}>
        <label for="gender-female" class="label label--inline">Female</label>
      </div>
    </div>
    <button type="button" class="inter_btn" id="addToBasketButton" onclick="continueToAddToBasket(event)"  tabindex="6" style="margin-top: 16px; display:block;border:0; width:100%">Continue</button>
  `;
};


window.continueToCheckoutWithUpsells = async function() {
  // IMPORTANT: Collect selected upsells BEFORE closing the modal
  const selectedUpsells = [];
  document.querySelectorAll('.bolt_on_option_box:checked').forEach(function(checkbox) {
    selectedUpsells.push({
      id: checkbox.value,
      title: checkbox.dataset.desc_title,
      price: checkbox.dataset.price,
      product_id: checkbox.dataset.handle,
      eurofins_code: checkbox.dataset.eurofins_code
    });
  });

  // Get the main product variant ID using helper function
  const variantId = getSelectedVariantId();
  
  if (!variantId) {
    console.error('Could not find variant ID. Debug info:', {
      selectedVariantsScript: !!document.querySelector('[data-selected-variant]'),
      checkedRadios: $('input[type="radio"]:checked').length,
      variantInput: !!document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]'),
      variantInputValue: document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value
    });
    alert('Please select a product variant.');
    return;
  }
  const productHandle = $('#product-handle').val();
  const eurofins_code = $('#eurofins_code').val();
  const sellingPlan = document.querySelector('form[data-type="add-to-cart-form"] input[name="selling_plan"]')?.value
  // Get patient data
  const patientData = window.tempPatientData || {};
  console.log(sellingPlan); 
  if(sellingPlan){
    var items = [{
      id: variantId,
      quantity: 1,
      selling_plan: sellingPlan,
      properties: createCartItemProperties(patientData, productHandle, eurofins_code)
    }];
  }else{
    var items = [{
      id: variantId,
      quantity: 1,
      properties: createCartItemProperties(patientData, productHandle, eurofins_code)
    }];
  }
  // Build items array for cart
  

  // Add selected upsells
  selectedUpsells.forEach(u => {
    items.push({
      id: Number(u.id),
      quantity: 1,
      properties: createCartItemProperties(patientData, u.product_id, u.eurofins_code)
    });
  });

  // Close the modal now (after collecting data)
  closeThankYouModal();

  // Add to cart
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({items}),
      credentials: 'same-origin'
    });

    if (!res.ok) {
      const errText = await res.text();
      console.error('Add to cart failed:', errText);
      alert('Could not add item to cart.');
      return;
    }

    // Redirect to cart (not checkout)
    window.location.href = '/cart';
  } catch (e) {
    console.error('Error adding to cart:', e);
    alert('Something went wrong adding the item to cart.');
  }
};

// Modal close handlers
document.getElementById('modalBackdrop')?.addEventListener('click', function(event) {
  if (event.target === this) {
    const thankYouModal = document.getElementById('thankYouModal');
    if (thankYouModal && thankYouModal.style.display === 'block') {
      closeThankYouModal();
    }
  }
});

document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    const thankYouModal = document.getElementById('thankYouModal');
    if (thankYouModal && thankYouModal.style.display === 'block') {
      closeThankYouModal();
    }
  }
});

const dobInput = document.getElementById('modal-dob');
if (dobInput) {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  dobInput.max = `${yyyy}-${mm}-${dd}`;
}

//JS for calling postcode search
window.addEventListener('load', function () {
  const input = document.getElementById('preSearchFormobile_venous');
  if (input) {
    input.addEventListener('keypress', function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        const id = e.target?.id;
        if (id) {
          preFindServiceProvidersPostcode(id);
          e.preventDefault();
        }
      }
    });
  }
});


function preFindServiceProvidersPostcode(target_id, requirement) {
  const postcode_box = document.getElementById(target_id);
  if (!postcode_box || postcode_box.value === '') {
    alert('Please enter a valid postcode');
    return;
  }

  const data = {
    'postcode': postcode_box.value,
  };
  const resultBlock = document.getElementById('postcode_locations_search_mob_result');
  if (resultBlock) {
    resultBlock.innerHTML = '<div class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>';
  }

  jQuery.ajax({
    url: "https://api.gbc.health/api/v2/shopify-get-mobile-clinics",
    type: 'GET',
    data: data,
    success: function (response) {
      const result_block = document.getElementById('postcode_locations_search_mob_result');
      if (result_block) {
        result_block.innerHTML = `<div class="d-flex pt-3"><div class="dashicons dashicons-success text-success mx-1"></div><div>` + response.message + `</div></div>`;
      }
    },
    error: function (xhr) {
      const result_block = document.getElementById('postcode_locations_search_mob_result');
      if (!result_block) return;
      
      let message = "An error occurred";

      if (xhr.responseJSON && xhr.responseJSON.message) {
        message = xhr.responseJSON.message;
      } else if (xhr.responseText) {
        try {
          const parsed = JSON.parse(xhr.responseText);
          if (parsed.message) {
            message = parsed.message;
          }
        } catch (e) {
          // Ignore parsing errors, use default message
        }
      }

      result_block.innerHTML = `<div class="d-flex pt-3">
          <div class="dashicons dashicons-no text-danger mx-1"></div>
          <div>${message}</div>
        </div>`;
    },
  });
}

// JS for women blood product
$(document).on('change', 'input[type="radio"][name*="subscription_picker"]', function () {
  $("input[name='selling_plan']").prop("checked", false);
});

$(document).on('change', 'input[type="radio"][name*="selling_plan"]', function () {
  $("input[name='selling_plan']").not(this).prop("checked", false);
  $("input[name='subscription_picker']").prop("checked", false);
  $(this).parents('label.full_width_variant').find('input[name="subscription_picker"]').prop('checked', true);
});

$('a.var_link').on('click', function(){
  const div_id = $(this).attr('data-attr');
  if (div_id) {
    $('div[data-rel="'+div_id+'"]').removeClass('hidden');
  }
});

